// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-media-uploader-unit {
  margin-left: 25px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name {
  position: relative;
  width: 100%;
  max-width: 222px;
  margin-top: 12px;
  border: 1px dashed #DCDCDE;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name img {
  cursor: pointer;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .uploaded-image {
  width: 100%;
  height: auto;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .ultimate-security-remove-image {
  position: absolute;
  top: -12px;
  right: -12px;
  cursor: pointer;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .no-media-wrap {
  padding: 30px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .no-media-wrap .img-wrap {
  border-radius: 50rem;
  border: 5px solid rgba(129, 133, 201, 0.2);
  margin-bottom: 6px;
  width: 36px;
  height: 36px;
  margin-left: auto;
  margin-right: auto;
  padding: 4px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .no-media-wrap .img-wrap img {
  display: inline-block;
  vertical-align: top;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .no-media-wrap .text-wrap * {
  display: block;
  text-align: center;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .no-media-wrap .text-wrap .title {
  color: #0C0C0C;
  font-weight: 500;
  font-size: 12px;
  line-height: 14.06px;
  letter-spacing: 0%;
  margin-bottom: 4px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-name .no-media-wrap .text-wrap .sub-title {
  color: #7C828B;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0%;
}
.ultimate-security-media-uploader-unit .media-uploader .file-detail .button-wrapper {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-detail .file-link {
  width: 100%;
  max-width: 375px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-detail .file-link label {
  width: 100%;
  display: block;
}
.ultimate-security-media-uploader-unit .media-uploader .file-detail .file-link .input-with-hints {
  margin-bottom: 8px;
}
.ultimate-security-media-uploader-unit .media-uploader .file-detail .file-link .input-with-hints input[type=text] {
  width: 100%;
}
.ultimate-security-media-uploader-unit .media-uploader .file-detail .file-link .input-with-hints.has-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: -26px;
}`, "",{"version":3,"sources":["webpack://./src/components/MediaUploader/MediaUploader.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AACQ;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AACZ;AAAY;EACI,eAAA;AAEhB;AAAY;EACI,WAAA;EACA,YAAA;AAEhB;AAAY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAEhB;AAAY;EACI,aAAA;AAEhB;AADgB;EACI,oBAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAGpB;AAFoB;EACI,qBAAA;EACA,mBAAA;AAIxB;AAAoB;EACI,cAAA;EACA,kBAAA;AAExB;AAAoB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAExB;AAAoB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAExB;AAMY;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAJhB;AAMY;EACI,WAAA;EACA,gBAAA;AAJhB;AAKgB;EACI,WAAA;EACA,cAAA;AAHpB;AAUgB;EACI,kBAAA;AARpB;AASoB;EACI,WAAA;AAPxB;AASoB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAPxB","sourcesContent":[".ultimate-security-media-uploader-unit {\n    margin-left: 25px;\n    .media-uploader {\n        .file-name {\n            position: relative;\n            width: 100%;\n            max-width: 222px;\n            margin-top: 12px;\n            border: 1px dashed #DCDCDE;\n            border-radius: 4px;\n            padding: 4px;\n            cursor: pointer;\n            img {\n                cursor: pointer;\n            }\n            .uploaded-image {\n                width: 100%;\n                height: auto;\n            }\n            .ultimate-security-remove-image {\n                position: absolute;\n                top: -12px;\n                right: -12px;\n                cursor: pointer;\n            }\n            .no-media-wrap {\n                padding: 30px;\n                .img-wrap {\n                    border-radius: 50rem;\n                    border: 5px solid #8185C933;\n                    margin-bottom: 6px;\n                    width: 36px;\n                    height: 36px;\n                    margin-left: auto;\n                    margin-right: auto;\n                    padding: 4px;\n                    img {\n                        display: inline-block;\n                        vertical-align: top;\n                    }\n                }\n                .text-wrap {\n                    * {\n                        display: block;\n                        text-align: center;\n                    }\n                    .title {\n                        color: #0C0C0C;\n                        font-weight: 500;\n                        font-size: 12px;\n                        line-height: 14.06px;\n                        letter-spacing: 0%;\n                        margin-bottom: 4px;\n                    }\n                    .sub-title {\n                        color: #7C828B;\n                        font-weight: 400;\n                        font-size: 10px;\n                        line-height: 14px;\n                        letter-spacing: 0%;\n                    }\n                }\n            }\n        }\n        .file-detail {\n            .upload-help-text {\n            }\n            .button-wrapper {\n                display: flex;\n                gap: 8px;\n                margin-bottom: 16px;\n            }\n            .file-link {\n                width: 100%;\n                max-width: 375px;\n                label {\n                    width: 100%;\n                    display: block;\n                }\n                .input-lavel,\n                .input-help {\n                }                \n                .input-lavel {\n                }\n                .input-with-hints {\n                    margin-bottom: 8px;\n                    input[type=\"text\"] {\n                        width: 100%;\n                    }\n                    &.has-hint {\n                        display: flex;\n                        align-items: center;\n                        gap: 6px;\n                        margin-left: -26px;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
